import loginRouter from './loginRouter';

export default loginRouter;
